module.exports = __webpack_public_path__ + "static/media/wings_image1.79da2bae.png";